// Filter the data based on search text, status, department, and date range
export const filterAdmissions = (data, searchText, statusFilter, departmentFilter, dateRange) => {
  return data.filter((admission) => {
    // Text search
    const textMatch =
      searchText === '' ||
      admission.patientName.toLowerCase().includes(searchText.toLowerCase()) ||
      admission.patientId.toLowerCase().includes(searchText.toLowerCase()) ||
      admission.admissionId.toLowerCase().includes(searchText.toLowerCase()) ||
      admission.roomAssigned.toLowerCase().includes(searchText.toLowerCase())

    // Status filter
    const statusMatch = statusFilter === 'all' || admission.admissionStatus === statusFilter

    // Department filter
    const departmentMatch = departmentFilter === 'all' || admission.department === departmentFilter

    // Date range filter
    let dateMatch = true
    if (dateRange && dateRange[0] && dateRange[1]) {
      const admissionDate = new Date(admission.dateOfAdmission)
      const startDate = dateRange[0].startOf('day').toDate()
      const endDate = dateRange[1].endOf('day').toDate()
      dateMatch = admissionDate >= startDate && admissionDate <= endDate
    }

    return textMatch && statusMatch && departmentMatch && dateMatch
  })
}
